import { render, staticRenderFns } from "./receiptGoodsTable.vue?vue&type=template&id=12a8469a&scoped=true&"
import script from "./receiptGoodsTable.vue?vue&type=script&lang=js&"
export * from "./receiptGoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./receiptGoodsTable.vue?vue&type=style&index=0&id=12a8469a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8469a",
  null
  
)

export default component.exports